import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  dateToISO8601,
  iso8601ToDate,
} from '../../../../../../../../AccountPerformanceReporting/helpers/dates';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { SingleDatePicker } from '../../../../../../../../CommonComponents/OPL/dates/SingleDatePicker/SingleDatePicker';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { AccountType } from '../../../../../../api/useAccountsOptionsQuery';

export const OriginationDate = () => {
  const { watch, control } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const originationFieldMap: Partial<Record<AccountType, string>> = {
    [AccountType.Mortgage]: 'OriginationDate',
    [AccountType.StudentLoan]: 'StudentLoanOriginationDate',
  };

  const fieldName = originationFieldMap[accountType];

  if (!fieldName) {
    return null;
  }

  const maxDate = accountType === AccountType.StudentLoan ? new Date() : undefined;

  return (
    <Box>
      <Text as="p" variant="formLabel" css="display: block;" mb="4">
        Origination Date
      </Text>

      <Box alignSelf="flex-start">
        <Controller
          control={control}
          name={`bankAccount.${fieldName}`}
          render={({ field: { value, onChange, disabled } }) => {
            return (
              <SingleDatePicker
                date={value ? iso8601ToDate(value) : undefined}
                onChange={date => onChange(dateToISO8601(date))}
                maxDate={maxDate}
                disabled={disabled}
              />
            );
          }}
        />
      </Box>
    </Box>
  );
};
